module.exports = __webpack_public_path__ + "img/female_2.3e66a486.png";